import { withBarWrapper } from '../HOCs/BarWrapper';

function SkuBar({ product }) {
    return product?.sku || '';
}

export default withBarWrapper(SkuBar, {
    customStyles: {
        fontSize: '10px',
    },
});
